// display none is used to hide the modal

$(document).ready(function() {
    $("#filterModal").css({"display": "none"});
});

$(document).ready(function() {
    // Use event delegation to bind the click event to the button
    $(document).on("click", "#ellipsisButton", function() {
        const filterModal = $("#filterModal");
        if (filterModal.is(":visible")) {
            filterModal.hide();
            $(".increase-min-height-f").css({"min-height": ""}); // Reset the height if needed
        } else {
            filterModal.show();
            $(".increase-min-height-f").css({"min-height": "800px"});
        }
    });
});

$(document).ready(function() {
    $('#custom-fields-form').hide();
$('#default-fields-btn').click(function() {
    $('#custom-fields-form').hide();
    $('#default-fields-form').show();
});

$('#custom-fields-btn').click(function() {
    $('#default-fields-form').hide();
    $('#custom-fields-form').show();
});
});


$(document).ready(function() {
    $("#filterModal").hide();
    $("#x-button").click(function() {
        $("#filterModal").hide();
        $(".card-to-expand").css({"min-height": "auto"});
    }
    );
});

$(document).ready(function() {
    $("#filter-button").click(function() {
        $("#filterModal").hide();
        $(".card").css({"min-height": "auto"});
    });
});

$(document).ready(function() {
    // Listen for changes to the radio buttons
    $('#default-fields-btn, #custom-fields-btn').on('change', function() {
      if ($('#default-fields-btn').is(':checked')) {
        // Set the value of the hidden field to "default-fields-form"
        $('#active-form').val('default-fields-form');
      } else if ($('#custom-fields-btn').is(':checked')) {
        // Set the value of the hidden field to "custom-fields-form"
        $('#active-form').val('custom-fields-form');
      }
    });
  });
